import React from 'react';
export const IframeScrollbarStyleContext = /*#__PURE__*/ React.createContext(null);
export const useScrollbarStyleOverrides = ()=>{
    const scrollbarStyleOverrides = React.useContext(IframeScrollbarStyleContext);
    if (!scrollbarStyleOverrides) {
        throw new Error('useScrollbarStyleOverride must be used within a IframeScrollbarStyleProvider');
    }
    return scrollbarStyleOverrides;
};
export const IframeScrollbarStyleProvider = ({ children, scrollbarStyleOverrides })=>{
    return /*#__PURE__*/ React.createElement(IframeScrollbarStyleContext.Provider, {
        value: scrollbarStyleOverrides
    }, children);
};

//# sourceMappingURL=IframeScrollbarStyleProvider.js.map